import {line} from '../path/shapes';
import markMultiItemPath from './markMultiItemPath';

export default markMultiItemPath('line', line);



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/marks/line.js
// module id = 1478
// module chunks = 0